import React, { useContext, useState } from "react";
import { createContext, ReactNode } from "react";

export interface IAnnounceParcelTrackerContext {
    carrier: string;
    setCarrier: (defaultCarrier: string) => void;
}

const defaultAnnounceParcelTrackerContext: IAnnounceParcelTrackerContext = {
    carrier: "",
    setCarrier: () => ({}),
};

const AnnounceParcelTrackerContext = createContext<IAnnounceParcelTrackerContext>(defaultAnnounceParcelTrackerContext);

export const AnnounceParcelTrackerContextProvider = ({ children }: { children: ReactNode }) => {
    const [defaultCarrier, setDefaultCarrier] = useState("");

    return <AnnounceParcelTrackerContext.Provider value={{ carrier: defaultCarrier, setCarrier: setDefaultCarrier }}>
        {children}
    </AnnounceParcelTrackerContext.Provider>;
};

export const useAnnounceParcelTrackerContext = () => {
    return useContext(AnnounceParcelTrackerContext);
};
